// extracted by mini-css-extract-plugin
export default {"editor":"TextEditor_editor__He3tt","invalid":"TextEditor_invalid__9J9Qu"};